import { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@contexts/AuthContext.tsx";
import ErrorBoundary from "../common/ErrorBoundary";
import LoadingFallback from "../common/LoadingFallback";

const ProtectedRoute: FC = () => {
  const { isAuthenticated, emailVerified, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingFallback message="Checking authentication..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  return (
    <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
  );
};

export default ProtectedRoute;
